<template>
  <div class="d-flex">
    <header-help-center-button />
    <header-group-dropdown
      :is-sys-admin="isSysAdmin"
      :user-id="userId"
      :group-id="groupId"
    />
  </div>
</template>

<script>
export default {
  name: 'HeaderFolderButtons',
  components: {
    HeaderHelpCenterButton: () => import('@/components/header/Buttons/HeaderHelpCenterButton.vue'),
    HeaderGroupDropdown: () => import('@/components/header/Buttons/HeaderGroupDropdown.vue'),
  },
  props: {
    userId: { type: Number },
    isSysAdmin: { type: Boolean },
    groupId: { type: Number },
  },
};
</script>
